import { render, staticRenderFns } from "./headerBase.vue?vue&type=template&id=80062eb4&scoped=true&"
import script from "./headerBase.vue?vue&type=script&lang=js&"
export * from "./headerBase.vue?vue&type=script&lang=js&"
import style0 from "./headerBase.vue?vue&type=style&index=0&id=80062eb4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80062eb4",
  null
  
)

export default component.exports